export default __webpack_public_path__ + "static/media/Group718.b32a81f6.svg";